(function (angular) {
  "use strict";

  angular
    .module("app")
    .controller(
      "myConnectionRequestsController",
      myConnectionRequestsController,
    );

  myConnectionRequestsController.$inject = [
    "connectionsPayload",
    "ConnectRequestsApi",
    "alerts",
    "thisUser",
    "$scope",
  ];

  function myConnectionRequestsController(
    connectionsPayload,
    ConnectRequestsApi,
    alerts,
    thisUser,
    $scope,
  ) {
    var vm = this;
    vm.limit = 3;

    // properties
    vm.requests = angular.copy(connectionsPayload);
    vm.requests.data = [];
    vm.filters = {
      received: true,
      with: "userFrom",
      page: 1,
      page_size: 999,
    };
    vm.acceptedRequests = [];

    // methods
    vm.updateFilters = updateFilters;
    vm.acceptRequest = acceptRequest;
    vm.ignoreRequest = ignoreRequest;

    // create a new connect resource for each one
    angular.forEach(connectionsPayload.data, function (connection) {
      vm.requests.data.push(new ConnectRequestsApi(connection).transform());
    });
    $scope.loadMore = function () {
      var increamented = vm.limit + 4;
      vm.limit =
        increamented > vm.requests.length ? vm.requests.length : increamented;
    };
    /**
     * Requests new connection requests from the server with the provided filters
     * @return {void}
     */
    function updateFilters() {
      vm.isLoading = true;
      ConnectRequestsApi.get(
        vm.filters,
        function (result) {
          vm.requests = result;
          vm.isLoading = false;
        },
        function () {
          vm.isLoading = false;
          alerts.emit({
            theme: "error",
            title: "Could not load more connections.",
            messages: ["Please try again later."],
          });
        },
      );
    }
    /**
     * Sets the status of a connection request to "accepted"
     * @param  {int} requestId - id of connection request to accept
     * @return {void}
     */
    function acceptRequest(requestId) {
      ConnectRequestsApi.update(
        {
          id: requestId,
          status: "accepted",
        },
        function (response) {
          var userFrom;
          angular.forEach(vm.requests.data, function (request) {
            if (request.id === requestId) {
              userFrom = request.user_from;
            }
          });

          alerts.emit({
            theme: "success",
            title: "You are now connected with " + userFrom.forename,
          });

          // Show message inside member directive
          vm.acceptedRequests.push(requestId);
        },
      );
    }

    /**
     * Sets the status of a connection request to "ignored"
     * @param  {int} requestId - id of connection request to accept
     * @return {void}
     */
    function ignoreRequest(requestId) {
      ConnectRequestsApi.update(
        {
          id: requestId,
          status: "ignored",
        },
        function (response) {
          // update status of local request
          angular.forEach(vm.requests.data, function (req) {
            if (req.id === response.id) {
              req.status = response.status;
            }
          });
        },
      );
    }
  }
})(angular);
